import { Component, OnInit, inject } from "@angular/core";

import { AnalyticsService } from "@shared/services/analytics/analytics.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class AppComponent implements OnInit {
  private analytics = inject(AnalyticsService);

  ngOnInit() {
    this.analytics.initScreenViewRouting();
  }
}
